import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getCCMDiagnosesByPatientId (patientId) {
		const response = await _axios.get(`/ccmdiagnosis/getbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM diagnosis');
	},
	async getCCMDiagnosesByCCMRecordId (ccmRecordId) {
		const response = await _axios.get(`/ccmdiagnosis/getbyccmrecordid/${ccmRecordId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM diagnosis');
	},
	async getCCMDiagnosis (id) {
		const response = await _axios.get(`/ccmdiagnosis/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM diagnosis');
	},
	async addCCMDiagnosis (body) {
		const response = await _axios.post('/ccmdiagnosis/', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM diagnosis');
	},
	async updateCCMDiagnosis (id, body) {
		const response = await _axios.put(`/ccmdiagnosis/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating CCM diagnosis');
	},
	async deleteCCMDiagnosis (id) {
		const response = await _axios.delete(`/ccmdiagnosis/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM diagnosis');
	},
};
